interface IProps {
  className?: string;
}

export const ErrorFaceIcon = ({ className }: IProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="96"
    height="96"
    viewBox="0 0 96 96"
    fill="none"
    aria-labelledby="title"
  >
    <title id="title">Error icon</title>
    <circle cx="48" cy="48" r="48" fill="#FFBB00" />
    <circle cx="32" cy="38" r="6" fill="#7A4E00" />
    <circle cx="64" cy="38" r="6" fill="#7A4E00" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M70 72C70 59.8497 60.1503 50 48 50C35.8497 50 26 59.8497 26 72H70Z"
      fill="#7A4E00"
    />
  </svg>
);
